import { render, staticRenderFns } from "./pref-category-list.vue?vue&type=template&id=1e54bdf1&"
import script from "./pref-category-list.vue?vue&type=script&lang=js&"
export * from "./pref-category-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports